import { Injectable } from '@angular/core';
import { RepositoryListResponseV2 } from '../@core/interfaces';
import { BehaviorSubject, Subject } from 'rxjs';
import { FilterParam, RangeParam, GDXSearchType, ListOfAllSelectedFilters, PathwaysDataType, StringToStringObjectMapping, TableSettingInterface } from '../../../@core/interfaces';
import { DatasetSourceV2, Hit, ElasticApiResponse } from 'polly-commons';
import { SchemaApiResponseInterface } from '../../../@core/interfaces/api-schema.interface';
import { Bucket } from '../../../@core/interfaces/dataset-filters.interface';

@Injectable({
  providedIn: 'root',
})
export class PollyOmixatlasStatemanagerService {
  public summaryFiltersSelected$: Subject<ListOfAllSelectedFilters> = new Subject<ListOfAllSelectedFilters>();
  public filterModalStatus$: Subject<FilterParam> = new Subject<FilterParam>();
  public filterStatus$: Subject<FilterParam> = new Subject<FilterParam>();
  public selectedFilter$: Subject<string> = new Subject<string>();
  public filterIndex$: Subject<{ index: number; isOntology: boolean }> = new Subject<{ index: number; isOntology: boolean }>();
  public tableSettingStatus$: Subject<TableSettingInterface[]> = new Subject<TableSettingInterface[]>();
  public metadataTableSettingStatus$: Subject<TableSettingInterface[]> = new Subject<TableSettingInterface[]>();
  public repoInfo$: BehaviorSubject<RepositoryListResponseV2 | undefined> = new BehaviorSubject<RepositoryListResponseV2 | undefined>(
    undefined
  );
  public firstTimeDatasetOptionClicked$: Subject<boolean> =  new Subject();
  public metadataChartsData$: BehaviorSubject<{metadataHits: Hit<DatasetSourceV2>[], metadataCount: number | undefined }> =
   new BehaviorSubject<{ metadataHits: Hit<DatasetSourceV2>[], metadataCount: number | undefined }>
   ({ metadataHits: [], metadataCount: undefined });
  public metadataTableData$: BehaviorSubject<{metadataHits: Hit<DatasetSourceV2>[], metadataSearchAfter: string[] | undefined }> =
   new BehaviorSubject<{ metadataHits: Hit<DatasetSourceV2>[], metadataSearchAfter: string[] | undefined }>
   ({ metadataHits: [], metadataSearchAfter: undefined });
  public rangeFilterValues$: Subject<RangeParam> = new Subject<RangeParam>();
  public isUserDataAtlas$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public cellFilterValues$: Subject<RangeParam> = new Subject<RangeParam>();
  public selectedDatasetId$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public clinicalSearchKey$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public gdxSearchType$: BehaviorSubject<GDXSearchType> = new BehaviorSubject<GDXSearchType>({ schemaType: 'comparison_data', searchType: 'searchByGene' });
  public gdxSchema$: BehaviorSubject<{ [key: string]: SchemaApiResponseInterface }> = new BehaviorSubject<{ [key: string]: SchemaApiResponseInterface }>({});
  public detailsComparisonTableData$: BehaviorSubject<StringToStringObjectMapping[] | null> =
    new BehaviorSubject<StringToStringObjectMapping[] | null>(null);
  public datasetOverviewData$: BehaviorSubject<ElasticApiResponse<DatasetSourceV2, undefined> | null> =
    new BehaviorSubject<ElasticApiResponse<DatasetSourceV2, undefined> | null>(null);
  public pathwaysData$: BehaviorSubject<PathwaysDataType[] | null> = new BehaviorSubject<PathwaysDataType[] | null>(null);
  public pathwayCategories$: BehaviorSubject<Bucket[] | null> = new BehaviorSubject<Bucket[] | null>(null);
  public comparisonVolcanoPlotExpanded$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public comparisonGeneTableExpanded$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public comparisonPathwayListExpanded$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public datasetDetailsTabIndex$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
}

